var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_ page_welfare_"},[(_vm.isShow)?_c('WelfareDetail',{attrs:{"data":_vm.detailData,"isHis":true,"providerCode":_vm.providerCode}}):_c('div',{staticClass:"tip"},[_vm._v("未查到")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }